/*********************** Custom JS for Boost AI Search & Discovery  ************************/
(() => {
  let tries = 0;
  let interval = setInterval(() => {
    const toolbarContainer = document.querySelector(
      ".boost-sd__toolbar-container"
    );
    const filterTree = document.querySelector(".boost-sd__filter-tree-wrapper");

    if (tries > 50) {
      clearInterval(interval);
      interval = null;
      return;
    }

    tries += 1;

    if (!toolbarContainer || !filterTree) {
      return;
    }

    clearInterval(interval);
    interval = null;

    filterTree.parentElement.insertBefore(toolbarContainer, filterTree);
  }, 100);
})();

// Sale tags
(() => {
  // Select the target node (where the changes will likely occur)
  const targetNode = document.querySelector("#main");

  // Options for the observer (which mutations to observe)
  const config = { childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  const callback = function (mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        // Check for new .boost-sd__product-label--customLabelByTag elements
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            node
              .querySelectorAll(".boost-sd__product-label--customLabelByTag")
              .forEach((labelNode) => {
                const labelText = labelNode.textContent.trim().toLowerCase();

                if (
                  labelText === "sale" ||
                  labelText.includes("% off")
                ) {
                  labelNode.classList.add(
                    "boost-sd__product-label--customLabelByTagSale"
                  );
                }
              });
          }
        });
      }
    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);
})();
